import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import PageMeta from "../components/PageMeta";
import Footer from "../components/Footer";
import FloatingFAQ from "../components/FloatingFAQ";

export default function PrivacyPolicy() {
  return (
    <div className="noise-bg">
      <PageMeta title="Privacy Policy | Averoan Technologies" />
      <Navbar />
      
      <section className="pt-32 pb-8 relative" data-testid="privacy-hero">
        <div className="hero-glow absolute top-0 right-0 opacity-30" />
        <div className="container-main relative z-10">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm mb-8 hover:text-[#D4FF00] transition-colors"
            style={{ color: '#A1A1AA' }}
          >
            <ArrowLeft size={16} /> Back to Home
          </Link>
          <h1 
            className="text-4xl md:text-6xl font-bold mb-4"
            style={{ fontFamily: '"Clash Display", sans-serif' }}
          >
            Privacy <span style={{ color: '#D4FF00' }}>Policy</span>
          </h1>
          <p style={{ color: '#A1A1AA' }}>Last updated: December 2025</p>
        </div>
      </section>

      <section className="py-12 md:py-20" style={{ background: '#18181B' }}>
        <div className="container-main">
          <div className="max-w-3xl mx-auto space-y-12">
            
            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                1. Information We Collect
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p>We collect information you provide directly to us, such as when you:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Fill out our contact form or consultation request</li>
                  <li>Subscribe to our newsletter</li>
                  <li>Request a quote for our services</li>
                  <li>Communicate with us via email or phone</li>
                </ul>
                <p>This information may include your name, email address, phone number, company name, and details about your project requirements.</p>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                2. How We Use Your Information
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p>We use the information we collect to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Respond to your inquiries and provide customer support</li>
                  <li>Send you project proposals and quotes</li>
                  <li>Communicate about projects you've engaged us for</li>
                  <li>Send marketing communications (with your consent)</li>
                  <li>Improve our website and services</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                3. Information Sharing
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>With service providers who assist in our operations</li>
                  <li>To comply with legal requirements</li>
                  <li>To protect our rights and safety</li>
                  <li>With your explicit consent</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                4. Data Security
              </h2>
              <p className="text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                5. Cookies and Tracking
              </h2>
              <p className="text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                Our website may use cookies and similar tracking technologies to enhance your browsing experience. You can control cookie preferences through your browser settings. Disabling cookies may affect some functionality of our website.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                6. Your Rights
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p>You have the right to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Access the personal information we hold about you</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your information</li>
                  <li>Opt-out of marketing communications</li>
                  <li>Withdraw consent where applicable</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                7. Contact Us
              </h2>
              <div className="text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p>If you have questions about this Privacy Policy or wish to exercise your rights, please contact us:</p>
                <div className="mt-4 p-6 rounded-xl" style={{ background: '#0F0F11', border: '1px solid rgba(255,255,255,0.1)' }}>
                  <p><strong className="text-white">Averoan Technologies Inc.</strong></p>
                  <p>Email: <a href="mailto:info@averoan.com" className="text-[#D4FF00] hover:underline">info@averoan.com</a></p>
                  <p>Phone: <a href="tel:+17787887273" className="text-[#D4FF00] hover:underline">(778) 788-7273</a></p>
                  <p>Location: Vancouver, BC, Canada</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      <FloatingFAQ />
    </div>
  );
}
